import { RemoteValidatedByProfessionals } from 'data/usecases';
import { HandleValidatedByProfessionalsUseCaseInterface } from 'domain/usecases';
import { makeApiUrlValidatedByProfessionals } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeHandleValidatedByProfessionals =
  (): HandleValidatedByProfessionalsUseCaseInterface =>
    new RemoteValidatedByProfessionals(
      makeApiUrlValidatedByProfessionals(),
      makeAxiosHttpClient(),
    );
